import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled';

import type { PreviewPanelActionGroupProps } from './types';

export const PreviewPanelActionGroup = ({ children, testId }: PreviewPanelActionGroupProps) => {
	return (
		<Inline testId={testId} space="space.050" alignBlock="center">
			{children}
		</Inline>
	);
};
